import {
  GET_TRANSLATIONS_REQUEST,
  GET_TRANSLATIONS_SUCCESS,
  GET_TRANSLATIONS_FAILURE,
} from '../constants'

const defaultLanguageState = {
  language: {},
  getPending: false,
  getSuccess: false,
  englishTranslations: {}
}

export default (state = defaultLanguageState, action) => {

  var newState = {...state}

  switch (action.type){

    case GET_TRANSLATIONS_REQUEST:
      newState.getSuccess = false;
      newState.getPending = true;
      return newState;
    case GET_TRANSLATIONS_SUCCESS:
      newState.language = action.data.language;
      newState.getSuccess = true;
      newState.getPending = false;
      if (action.data.language.name === "English") {
        newState.englishTranslations = action.data.language.translations;
      }
      return newState;
    case GET_TRANSLATIONS_FAILURE:
      newState.getSuccess = false;
      newState.getPending = false;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/language.js